<template>
  <div class="controls">
    <div class="control-group">
      <div style="display: flex; align-items: flex-start;">
        <div style="margin-right: 10px;">
          <div>
            <el-date-picker
                ref="datePicker"
                v-model="localCurrentDate"
                type="date"
                placeholder="选择日期"
                format="MM月dd日"
                value-format="yyyy-MM-dd"
                @change="onDateChange"
                @focus="onDatePickerFocus"
                @blur="onDatePickerBlur"
                :clearable="false"
                style="width: 120px; cursor: pointer;"
                :editable="false"
                :picker-options="localPickerOptions"
                class="custom-date-picker">
            </el-date-picker>
          </div>
          <div>
            <el-select v-model="localSelectedType" @change="onTypeChange" placeholder="请选择作业类型" style="width: 120px; margin-top: 5px;" class="center-select">
              <el-option
                  v-for="type in homeworkTypes"
                  :key="type.id"
                  :label="type.name"
                  :value="type.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div style="margin-right: 10px;">
          <div style="display: flex; margin-bottom: 5px;">
            <el-button @click="onPrevDay" style="width: 70px; text-align: center; margin-right: 5px; display: flex; align-items: center; justify-content: center; border-radius: 10px; font-weight: bold;">前一天</el-button>
            <el-button @click="onNextDay" style="width: 70px; text-align: center; display: flex; align-items: center; justify-content: center; border-radius: 10px; font-weight: bold;">后一天</el-button>
          </div>
          <div style="display: flex;">
            <el-button @click="onPrevAssignment" style="width: 70px; text-align: center; margin-right: 5px; display: flex; align-items: center; justify-content: center; border-radius: 10px; font-weight: bold;">前一次</el-button>
            <el-button @click="onNextAssignment" style="width: 70px; text-align: center; display: flex; align-items: center; justify-content: center; border-radius: 10px; font-weight: bold;">后一次</el-button>
          </div>
        </div>

        <div style="display: flex; align-items: flex-start;">
          <div style="margin-right: 10px; flex: 1;">
            <el-input
                v-model="localHomeworkContent"
                placeholder="请输入作业内容"
                style="width: 100%;"
                @focus="onShowHomeworkContentDialog"
                readonly
                class="homework-content-input el-input">
              <template slot="prepend">作业内容</template>
            </el-input>
            <div style="display: flex; margin-top: 10px;">
              <el-button @click="onResetStatus" type="warning" :disabled="!isAssigned" style="margin-right: 10px; border-radius: 10px; font-weight: bold;">重置本页面订正状态</el-button>
              <el-button @click="onSetAllFinished" type="success" :disabled="!isAssigned" style="border-radius: 10px; font-weight: bold;">设置本页面全部订完</el-button>
            </div>
          </div>
        </div>

        <div class="check-students-section">
          <div class="check-student-input-row" style="margin-bottom: 10px;">
            <el-autocomplete
                v-model="localSearchKeyword"
                :fetch-suggestions="querySuggestions"
                placeholder="请输入学号或姓名"
                @select="onSelectStudent"
                style="width: 100%;"
                :trigger-on-focus="true"
                class="custom-autocomplete">
              <template slot="prepend">彻查学生</template>
              <template slot-scope="{ item }">
                <div class="name">{{ item.studentNumber }} - {{ item.name }}</div>
              </template>
            </el-autocomplete>
          </div>
          <div class="action-buttons-row" style="display: flex;">
            <el-button @click="onShowUnfinishedStudents" style="margin-right: 10px; border-radius: 10px; font-weight: bold;">本作业欠交名单</el-button>
            <el-button @click="onShowImportStudentsDialog" style="flex: 1; border-radius: 10px; font-weight: bold;">批量录入</el-button>
          </div>
        </div>
      </div>
    </div>
    

    
    <!-- 学生历史记录弹窗 -->
    <StudentHistoryDialog 
      :visible.sync="studentHistoryDialogVisible"
      :student-name="selectedStudentName"
      :subject-name="currentSubject"
      :records="studentHistoryRecords"
      :show-no-records="showStudentNoRecords"
      :types="homeworkTypes"
      :sort-field="studentHistorySortField"
      :sort-order="studentHistorySortOrder"
      @sort="sortStudentHistory"
      @mark="markAsFinished"
      @edit="editHomeworkContent"
      @locate="locateToRecord"
      @export="exportStudentData" />

    <!-- 历史欠交学生弹窗 -->
    <UnfinishedStudentsDialog
      :visible.sync="unfinishedStudentsDialogVisible"
      :students="unfinishedStudents"
      :type-name="currentTypeName"
      :sort-field="unfinishedStudentsSortField"
      :sort-order="unfinishedStudentsSortOrder"
      :class-id="classId"
      @sort="sortUnfinishedStudents"
      @mark="markUnfinishedStudentAsFinished"
      @locate="locateToUnfinishedRecord"
      @content-updated="handleContentUpdated" />

    <!-- 作业内容弹窗 -->
    <HomeworkContentDialog
      :visible.sync="homeworkContentDialogVisible"
      :content="tempHomeworkContent"
      :is-assigned="isAssigned"
      @close="closeHomeworkContentDialog"
      @save="saveHomeworkContentFromDialog"
      append-to-body />

    <!-- 批量录入弹窗 -->
    <ImportStudentsDialog
      :visible.sync="importStudentsDialogVisible"
      :text="importStudentsText"
      :is-assigned="isAssigned"
      @update:text="val => importStudentsText = val"
      @process="processImportStudents" />

    <!-- 无法匹配的学生名单弹窗 -->
    <UnmatchedStudentsDialog
      :visible.sync="unmatchedStudentsDialogVisible"
      :text="unmatchedStudentsText" />
  </div>
</template>

<style scoped>
/* 作业内容输入框样式 */
.homework-content-input >>> .el-input__inner {
  border-radius: 0 10px 10px 0;
}

.homework-content-input >>> .el-input-group__prepend {
  border-radius: 10px 0 0 10px;
  background: white;
  color: #606266;
  font-weight: bold;
  padding: 0 15px;
  border: 1px solid #DCDFE6;
  border-right: none;
}

.homework-content-input >>> .el-input-group__prepend .el-input__icon {
  color: #606266;
}

/* 彻查学生输入框样式 */
.custom-autocomplete >>> .el-input__inner {
  border-radius: 0 10px 10px 0;
}

.custom-autocomplete >>> .el-input-group__prepend {
  border-radius: 10px 0 0 10px;
  background: white;
  color: #606266;
  font-weight: bold;
  padding: 0 15px;
  border: 1px solid #DCDFE6;
  border-right: none;
}

.custom-autocomplete >>> .el-input-group__prepend .el-input__icon {
  color: #606266;
}
</style>

<script>
import Utils from '../../utils/Utils'
import StudentHistoryDialog from './dialogs/StudentHistoryDialog.vue'
import UnfinishedStudentsDialog from './dialogs/UnfinishedStudentsDialog.vue'
import HomeworkContentDialog from './dialogs/HomeworkContentDialog.vue'
import ImportStudentsDialog from './dialogs/ImportStudentsDialog.vue'
import UnmatchedStudentsDialog from './dialogs/UnmatchedStudentsDialog.vue'
import EventBus from '../../utils/EventBus'

export default {
  name: 'ControlPanel',
  components: {
    StudentHistoryDialog,
    UnfinishedStudentsDialog,
    HomeworkContentDialog,
    ImportStudentsDialog,
    UnmatchedStudentsDialog
  },
  props: {
    currentDate: {
      type: String,
      default: ''
    },
    selectedType: {
      type: Number,
      default: 1
    },
    homeworkTypes: {
      type: Array,
      default: () => []
    },
    homeworkContent: {
      type: String,
      default: ''
    },
    searchKeyword: {
      type: String,
      default: ''
    },
    pickerOptions: {
      type: Object,
      default: () => ({})
    },
    classId: {
      type: Number,
      default: null
    },
    subjectIndex: {
      type: Number,
      default: 0
    },
    students: {
      type: Array,
      default: () => []
    },
    correctionRecords: {
      type: Array,
      default: () => []
    },
    isAssigned: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localCurrentDate: this.currentDate,
      localSelectedType: this.selectedType,
      localHomeworkContent: this.homeworkContent,
      localSearchKeyword: this.searchKeyword,
      localPickerOptions: this.pickerOptions,
      localHomeworkTypes: this.homeworkTypes,
      homeworkContentDialogVisible: false,
      tempHomeworkContent: '',
      // 添加内部状态用于控制高亮快捷按钮
      highlightedShortcut: '',
      // 添加编辑行状态
      editingRow: null,
      // 添加批量录入相关数据
      importStudentsText: '',
      importStudentsDialogVisible: false,
      unmatchedStudentsDialogVisible: false,
      unmatchedStudentsText: '',
      // 添加学生历史记录相关数据
      studentHistoryRecords: [],
      unfinishedStudents: [],
      studentHistoryDialogVisible: false,
      unfinishedStudentsDialogVisible: false,
      // 添加学生欠交数量相关数据
      showUnfinishedCount: false,
      studentUnfinishedCounts: {},
      // 添加排序状态相关数据
      studentHistorySortField: 'typeName', // 默认排序字段
      studentHistorySortOrder: 'asc', // 默认排序顺序
      // 历史欠交学生排序状态
      unfinishedStudentsSortField: 'date', // 默认排序字段
      unfinishedStudentsSortOrder: 'asc', // 默认排序顺序
      // 添加选中学生相关数据
      selectedStudentName: '', // 当前选中学生的名字
      showStudentNoRecords: false, // 显示无记录状态
    }
  },
  computed: {
    currentTypeName() {
      // 获取当前选中作业类型的名称
      const currentType = this.localHomeworkTypes.find(type => type.id === this.localSelectedType)
      return currentType ? currentType.name : ''
    },
    currentSubject() {
      const subjects = ['语文', '数学', '英语'];
      return subjects[this.subjectIndex];
    }
  },
  
  watch: {
    currentDate(newVal) {
      this.localCurrentDate = newVal
    },
    selectedType(newVal) {
      this.localSelectedType = newVal
    },
    studentHistoryDialogVisible(newVal) {
      if (!newVal) {
        // 弹窗关闭时重置状态
        this.showStudentNoRecords = false;
        this.studentHistoryRecords = [];
        this.selectedStudentName = '';
      }
    },
    homeworkContent(newVal) {
      this.localHomeworkContent = newVal
    },
    searchKeyword(newVal) {
      this.localSearchKeyword = newVal
    },
    homeworkTypes: {
      handler(newVal) {
        this.localHomeworkTypes = newVal
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 工具方法：获取当前日期格式
    getCurrentDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    formatDate(dateString) {
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    // 日期选择器获得焦点时
    onDatePickerFocus() {
      Utils.onDatePickerFocus(this)
    },

    // 日期选择器失去焦点时（面板关闭时）
    onDatePickerBlur() {
      Utils.onDatePickerBlur(this)
    },
    
    // 根据当前日期设置高亮的快捷按钮
    setHighlightedShortcut() {
      const offset = this.calculateDateOffset(this.localCurrentDate)
      if (offset === -2) {
        this.highlightedShortcut = '前天'
      } else if (offset === -1) {
        this.highlightedShortcut = '昨天'
      } else if (offset === 0) {
        this.highlightedShortcut = '今天'
      } else {
        this.highlightedShortcut = ''
      }
      
      // 强制更新日期选择器高亮状态
      this.forceUpdateDatepickerHighlight()
    },
    
    calculateDateOffset(dateString) {
      const selectedDate = new Date(dateString)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      selectedDate.setHours(0, 0, 0, 0)
      const diffTime = selectedDate.getTime() - today.getTime()
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    },
    
    forceUpdateDatepickerHighlight() {
      // 查找日期选择器中的快捷按钮并更新高亮状态
      this.$nextTick(() => {
        if (this.$refs.datePicker && this.$refs.datePicker.picker && this.$refs.datePicker.picker.$el) {
          // 使用更精确的选择器来定位快捷按钮
          const shortcuts = this.$refs.datePicker.picker.$el.querySelectorAll('.el-picker-panel__sidebar .el-picker-panel__shortcut')
          shortcuts.forEach((button) => {
            // 移除所有高亮类
            button.classList.remove('highlighted')
            
            // 根据按钮文本和highlightedShortcut状态添加高亮类
            if (button.textContent === this.highlightedShortcut) {
              button.classList.add('highlighted')
            }
          })
        }
      })
    },
    
    // 日期变更处理
    onDateChange(value) {
      console.log('ControlPanel: onDateChange 被调用，新日期:', value);
      this.localCurrentDate = value
      this.$emit('date-change', value)
      this.loadHomeworkContent()
    },
    
    // 作业类型变更处理
    onTypeChange(value) {
      console.log('ControlPanel: onTypeChange 被调用，新类型:', value);
      this.localSelectedType = value
      this.$emit('type-change', value)
      this.loadHomeworkContent()
      // 只发出data-changed事件，让StudentGrid自己处理统计更新
    },
    
    // 前一天处理
    onPrevDay() {
      const date = new Date(this.localCurrentDate)
      date.setDate(date.getDate() - 1)
      this.localCurrentDate = this.formatDate(date)
      this.$emit('date-change', this.localCurrentDate)
      this.loadHomeworkContent()
      // 只发出data-changed事件，让StudentGrid自己处理统计更新
    },
    
    // 后一天处理
    onNextDay() {
      const date = new Date(this.localCurrentDate)
      date.setDate(date.getDate() + 1)
      this.localCurrentDate = this.formatDate(date)
      this.$emit('date-change', this.localCurrentDate)
      this.loadHomeworkContent()
      // 只发出data-changed事件，让StudentGrid自己处理统计更新
    },
    
    // 前一次作业处理
    onPrevAssignment() {
      // 获取前一次布置作业的日期
      let url = `/correctionRecords/previousAssignedDate?typeId=${this.localSelectedType}&currentDate=${this.localCurrentDate}`
      if (this.classId) {
        url = `/correctionRecords/previousAssignedDate?typeId=${this.localSelectedType}&currentDate=${this.localCurrentDate}&classId=${this.classId}`
      }
      this.$http.get(url)
          .then(response => {
            if (response.data) {
              this.localCurrentDate = response.data
              this.$emit('date-change', this.localCurrentDate)
              this.loadHomeworkContent()
            } else {
              this.$message({
                type: 'info',
                message: '当前已是该类型作业最早的布置日期'
              })
            }
          })
          .catch(error => {
            console.error('获取前一次布置日期失败:', error)
            this.$message({
              type: 'error',
              message: '获取前一次布置日期失败'
            })
          })
    },
    
    // 后一次作业处理
    onNextAssignment() {
      // 获取后一次布置作业的日期
      let url = `/correctionRecords/nextAssignedDate?typeId=${this.localSelectedType}&currentDate=${this.localCurrentDate}`
      if (this.classId) {
        url = `/correctionRecords/nextAssignedDate?typeId=${this.localSelectedType}&currentDate=${this.localCurrentDate}&classId=${this.classId}`
      }
      this.$http.get(url)
          .then(response => {
            if (response.data) {
              this.localCurrentDate = response.data
              this.$emit('date-change', this.localCurrentDate)
              // 由父组件处理完整的数据加载，这里只处理本地状态更新
            } else {
              this.$message({
                type: 'info',
                message: '当前已是该类型作业最后的布置日期'
              })
            }
          })
          .catch(error => {
            console.error('获取后一次布置日期失败:', error)
            this.$message({
              type: 'error',
              message: '获取后一次布置日期失败'
            })
          })
    },
    
    // 重置状态处理
    onResetStatus() {
      this.$confirm('此操作将重置本页面为未布置状态，如果本页面有设置作业内容，也将一并重置，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = `/correctionRecords/reset?date=${this.localCurrentDate}&typeId=${this.localSelectedType}`
        if (this.classId) {
          url = `/correctionRecords/reset?date=${this.localCurrentDate}&typeId=${this.localSelectedType}&classId=${this.classId}`
        }
        this.$http.put(url)
            .then(() => {
              this.$emit('reset-status')
              this.$message({
                type: 'success',
                message: '重置成功!'
              })
            })
            .catch(error => {
              console.error('重置状态失败:', error)
              this.$message({
                type: 'error',
                message: '重置失败: ' + (error.response?.data?.message || error.message || '未知错误')
              })
            })
      }).catch(() => {
        // 用户取消操作
      })
    },
    
    // 设置全部完成处理
    onSetAllFinished() {
      this.$confirm('此操作将设置本页面所有学生为订正完成状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = `/correctionRecords/setAllFinished?date=${this.localCurrentDate}&typeId=${this.localSelectedType}`
        if (this.classId) {
          url = `/correctionRecords/setAllFinished?date=${this.localCurrentDate}&typeId=${this.localSelectedType}&classId=${this.classId}`
        }
        this.$http.put(url)
            .then(() => {
              this.loadData()
              this.$emit('set-all-finished')
              // 只发出事件，让StatisticsPanel自己处理统计更新
              this.$message({
                type: 'success',
                message: '设置成功!'
              })
            })
            .catch(error => {
              console.error('设置全部完成失败:', error)
              this.$message({
                type: 'error',
                message: '设置失败: ' + (error.response?.data?.message || error.message || '未知错误')
              })
            })
      }).catch(() => {
        // 用户取消操作
      })
    },
    
    // 显示欠交学生名单
    onShowUnfinishedStudents() {
      this.showUnfinishedStudents()
    },
    
    // 显示批量录入对话框
    onShowImportStudentsDialog() {
      this.showImportStudentsDialog()
    },
    
    // 显示作业内容对话框
    onShowHomeworkContentDialog() {
      // 将当前作业内容复制到临时变量
      this.tempHomeworkContent = this.localHomeworkContent
      // 显示作业内容输入弹窗
      this.homeworkContentDialogVisible = true
    },
    
    // 选择学生
    onSelectStudent(item) {
      this.handleSelectStudent(item)
    },
    
    // 处理学生选择
    handleSelectStudent(item) {
      // 立即显示弹窗，显示loading状态
      this.selectedStudentName = item.name
      this.studentHistoryRecords = [] // 先清空数据
      this.studentHistoryDialogVisible = true
      
      // 获取学生历史欠交记录
      let url = `/correctionRecords/studentUnfinishedAllTypesWithContent?studentId=${item.id}&subjectId=${this.subjectIndex + 1}`
      if (this.classId) {
        url = `/correctionRecords/studentUnfinishedAllTypesWithContent?studentId=${item.id}&subjectId=${this.subjectIndex + 1}&classId=${this.classId}`
      }
      this.$http.get(url)
            .then(response => {
              // 过滤掉未来日期的记录
              const today = new Date()
              today.setHours(0, 0, 0, 0)

              let studentHistoryRecords = response.data
                .filter(record => {
                  const recordDate = new Date(record.date)
                  recordDate.setHours(0, 0, 0, 0)
                  return recordDate <= today
                })
                .map(record => {
                  return {
                    ...record
                  }
                })

              this.studentHistoryRecords = studentHistoryRecords
                  
              if (this.studentHistoryRecords.length > 0) {
                // 默认按作业类型升序排序
                this.sortStudentHistory('typeName', 'asc')
              } else {
                // 没有记录时，显示完成信息
                this.showStudentNoRecords = true;
              }
          })
          .catch((e) => {
            console.error('获取学生历史欠交记录失败:', e)
            this.$message({
              type: 'error',
              message: '获取数据失败: ' + (e.response?.data?.message || e.message || '未知错误')
            })
          })
    },
    
    // 查询建议
    querySuggestions(queryString, cb) {
      // 当queryString为空时，显示所有学生（按学号排序）
      if (!queryString) {
        // 创建学生列表的副本并按学号排序
        const sortedStudents = [...this.students].sort((a, b) => {
          return a.studentNumber.localeCompare(b.studentNumber, undefined, {
            numeric: true,
            sensitivity: 'base'
          })
        })
        cb(sortedStudents)
        return
      }

      // 当有查询字符串时，按原有逻辑过滤学生
      let searchUrl = `/students/search?keyword=${queryString}`
      if (this.classId) {
        searchUrl = `/students/search?keyword=${queryString}&classId=${this.classId}`
      }
      this.$http.get(searchUrl)
          .then(response => {
            cb(response.data)
          })
    },
    
    // 作业内容相关方法
    loadHomeworkContent() {
      let url = `/homeworkContents?date=${this.localCurrentDate}&typeId=${this.localSelectedType}`
      if (this.classId) {
        url = `/homeworkContents?date=${this.localCurrentDate}&typeId=${this.localSelectedType}&classId=${this.classId}`
      }
      this.$http.get(url)
          .then(response => {
            // 检查响应状态码，204表示无内容
            if (response.status === 204) {
              this.localHomeworkContent = ''
            } else {
              this.localHomeworkContent = response.data ? response.data.content : ''
            }
          })
          .catch(error => {
            this.localHomeworkContent = ''
          })
    },
    
    saveHomeworkContent() {
      let url = `/homeworkContents?date=${this.localCurrentDate}&typeId=${this.localSelectedType}`
      if (this.classId) {
        url = `/homeworkContents?date=${this.localCurrentDate}&typeId=${this.localSelectedType}&classId=${this.classId}`
      }
      this.$http.get(url)
          .then(response => {
            // 检查响应状态码，204表示无内容
            let content
            if (response.status === 204) {
              content = {}
            } else {
              content = response.data || {}
            }

            content.date = this.localCurrentDate
            content.homeworkTypeId = this.localSelectedType
            content.content = this.localHomeworkContent

            // 如果有班级ID，添加到内容中
            if (this.classId) {
              content.classId = this.classId
            }

            return this.$http.post('/homeworkContents', content)
          })
          .then(response => {
            // 保存成功后的处理
            this.$message({
              type: 'success',
              message: '作业内容保存成功!'
            })
            // 重新加载作业内容以确认更新
            this.loadHomeworkContent();
          })
          .catch(error => {
            // 新建
            const content = {
              date: this.localCurrentDate,
              homeworkTypeId: this.localSelectedType,
              content: this.localHomeworkContent
            }

            // 如果有班级ID，添加到内容中
            if (this.classId) {
              content.classId = this.classId
            }

            return this.$http.post('/homeworkContents', content)
                .then(response => {
                  // 保存成功后的处理
                  this.$message({
                    type: 'success',
                    message: '作业内容保存成功!'
                  })
                  // 重新加载作业内容以确认更新
                  this.loadHomeworkContent();
                })
                .catch(error => {
                  // 保存失败的处理
                  this.$message({
                    type: 'error',
                    message: '作业内容保存失败: ' + (error.response?.data?.message || error.message || '未知错误')
                  })
                })
          })
    },
    
    closeHomeworkContentDialog() {
      this.homeworkContentDialogVisible = false
    },
    
    handleEnterKey() {
      this.saveHomeworkContentFromDialog()
    },
    
    saveHomeworkContentFromDialog(contentFromDialog) {
      console.log('saveHomeworkContentFromDialog called with:', contentFromDialog);
      console.log('Type of contentFromDialog:', typeof contentFromDialog);
      
      // 检查参数是否为事件对象，如果是则尝试从中提取值
      if (contentFromDialog && typeof contentFromDialog === 'object' && contentFromDialog.target) {
        // 这可能是一个事件对象，尝试获取相关值
        if (contentFromDialog.target && contentFromDialog.target.value !== undefined) {
          // 这是一个输入事件，使用其值
          this.tempHomeworkContent = contentFromDialog.target.value;
        } else {
          // 这是一个普通的事件对象，但不是输入事件
          console.log('Received event object, ignoring');
          return;
        }
      } else {
        // 参数不是事件对象，直接使用它作为内容
        if (contentFromDialog !== undefined) {
          this.tempHomeworkContent = contentFromDialog;
          console.log('Updated tempHomeworkContent to:', this.tempHomeworkContent);
        } else {
          console.log('Parameter is undefined, using current tempHomeworkContent');
        }
      }

      console.log('Current editingRow:', this.editingRow);
      console.log('Has editingRow:', !!this.editingRow);
      
      // 更新当前编辑行的内容
      if (this.editingRow) {
        console.log('Editing row exists, checking type of record...');
        
        // 如果是学生历史欠交记录弹窗
        if (this.studentHistoryRecords && this.studentHistoryRecords.includes(this.editingRow)) {
          console.log('Processing student history record edit');
          // 构造保存作业内容所需的数据
          const contentData = {
            date: this.editingRow.date,
            homeworkTypeId: this.editingRow.homeworkTypeId,
            content: this.tempHomeworkContent
          }

          // 如果有班级ID，添加到内容中
          if (this.classId) {
            contentData.classId = this.classId
          }

          // 保存作业内容到服务器
          this.$http.post('/homeworkContents', contentData)
              .then(response => {
                console.log('Server response:', response);
                // 保存成功后，更新当前行的内容
                this.editingRow.content = this.tempHomeworkContent

                // 同时更新同一弹窗中具有相同日期和作业类型的所有记录
                for (let i = 0; i < this.studentHistoryRecords.length; i++) {
                  const record = this.studentHistoryRecords[i]
                  // 确保日期格式一致后再比较
                  const editingRowDate = new Date(this.editingRow.date).toDateString()
                  const recordDate = new Date(record.date).toDateString()

                  if (recordDate === editingRowDate &&
                      record.homeworkTypeId === this.editingRow.homeworkTypeId) {
                    this.$set(this.studentHistoryRecords, i, {
                      ...record,
                      content: this.tempHomeworkContent
                    })
                  }
                }

                // 检查是否需要更新主页面的作业内容（如果编辑的日期和作业类型与当前页面相同）
                const editingRowDateStr = new Date(this.editingRow.date).toDateString();
                const currentPageDateStr = new Date(this.localCurrentDate).toDateString();
                if (editingRowDateStr === currentPageDateStr && this.editingRow.homeworkTypeId === this.localSelectedType) {
                  this.localHomeworkContent = this.tempHomeworkContent;
                }

                this.$message({
                  type: 'success',
                  message: '作业内容保存成功!'
                })
              })
              .catch(error => {
                console.error('Error saving homework content:', error);
                this.$message({
                  type: 'error',
                  message: '作业内容保存失败: ' + (error.response?.data?.message || error.message || '未知错误')
                })
              })
              .finally(() => {
                console.log('Closing dialog and clearing editing row');
                // 隐藏弹窗
                this.homeworkContentDialogVisible = false
                // 清空编辑行
                this.editingRow = null
              })
        }
        // 如果是历史欠交学生弹窗
        else if (this.unfinishedStudents && this.unfinishedStudents.includes(this.editingRow)) {
          console.log('Processing unfinished students record edit');
          // 构造保存作业内容所需的数据
          const contentData = {
            date: this.editingRow.date,
            homeworkTypeId: this.localSelectedType,
            content: this.tempHomeworkContent
          }

          // 如果有班级ID，添加到内容中
          if (this.classId) {
            contentData.classId = this.classId
          }

          // 保存作业内容到服务器
          this.$http.post('/homeworkContents', contentData)
              .then(response => {
                console.log('Server response:', response);
                // 保存成功后，更新当前行的内容
                this.editingRow.content = this.tempHomeworkContent

                // 同时更新同一弹窗中具有相同日期的所有记录（因为这个弹窗中所有记录都是同一作业类型）
                for (let i = 0; i < this.unfinishedStudents.length; i++) {
                  const student = this.unfinishedStudents[i]
                  if (student.date === this.editingRow.date) {
                    this.$set(this.unfinishedStudents, i, {
                      ...student,
                      content: this.tempHomeworkContent
                    })
                  }
                }

                // 检查是否需要更新主页面的作业内容（如果编辑的日期和作业类型与当前页面相同）
                const editingRowDateStr = new Date(this.editingRow.date).toDateString();
                const currentPageDateStr = new Date(this.localCurrentDate).toDateString();
                if (editingRowDateStr === currentPageDateStr && this.localSelectedType === this.editingRow.homeworkTypeId) {
                  this.localHomeworkContent = this.tempHomeworkContent;
                }

                this.$message({
                  type: 'success',
                  message: '作业内容保存成功!'
                })
              })
              .catch(error => {
                console.error('Error saving homework content:', error);
                this.$message({
                  type: 'error',
                  message: '作业内容保存失败: ' + (error.response?.data?.message || error.message || '未知错误')
                })
              })
              .finally(() => {
                console.log('Closing dialog and clearing editing row');
                // 隐藏弹窗
                this.homeworkContentDialogVisible = false
                // 清空编辑行
                this.editingRow = null
              })
        }
        // 如果editingRow不在已知的数组中，但仍包含必要的字段，仍然进行处理
        else {
          console.log('Editing row does not match any known record arrays, but may still be valid');
          console.log('Checking if editingRow has required fields...');
          
          // 检查editingRow是否有必要字段
          if (this.editingRow.date && (this.editingRow.homeworkTypeId || this.localSelectedType)) {
            console.log('Valid editingRow found, processing as general record');
            
            // 构造保存作业内容所需的数据
            const contentData = {
              date: this.editingRow.date,
              homeworkTypeId: this.editingRow.homeworkTypeId || this.localSelectedType,
              content: this.tempHomeworkContent
            }

            // 如果有班级ID，添加到内容中
            if (this.classId) {
              contentData.classId = this.classId
            }

            // 保存作业内容到服务器
            this.$http.post('/homeworkContents', contentData)
                .then(response => {
                  console.log('Server response:', response);
                  // 保存成功后，更新当前行的内容
                  if (this.editingRow) {
                    this.editingRow.content = this.tempHomeworkContent
                  }

                  // 检查是否需要更新主页面的作业内容（如果编辑的日期和作业类型与当前页面相同）
                  const editingRowDateStr = new Date(this.editingRow.date).toDateString();
                  const currentPageDateStr = new Date(this.localCurrentDate).toDateString();
                  if (editingRowDateStr === currentPageDateStr && (this.editingRow.homeworkTypeId || this.localSelectedType) === this.localSelectedType) {
                    this.localHomeworkContent = this.tempHomeworkContent;
                  }

                  this.$message({
                    type: 'success',
                    message: '作业内容保存成功!'
                  })
                })
                .catch(error => {
                  console.error('Error saving homework content:', error);
                  this.$message({
                    type: 'error',
                    message: '作业内容保存失败: ' + (error.response?.data?.message || error.message || '未知错误')
                  })
                })
                .finally(() => {
                  console.log('Closing dialog and clearing editing row');
                  // 隐藏弹窗
                  this.homeworkContentDialogVisible = false
                  // 清空编辑行
                  this.editingRow = null
                })
          } else {
            console.log('Editing row does not have required fields, falling back to main page edit');
            // 如果editingRow没有必需字段，则视为普通编辑
            this.localHomeworkContent = this.tempHomeworkContent;
            // 保存作业内容到服务器
            this.saveHomeworkContent()
            // 隐藏弹窗
            this.homeworkContentDialogVisible = false
            // 清空编辑行
            this.editingRow = null
          }
        }
      } else {
        console.log('No editing row, treating as main page edit');
        // 如果没有编辑行，说明是从主页面调用的
        // 将临时变量的值保存到作业内容
        this.localHomeworkContent = this.tempHomeworkContent;
        // 保存作业内容到服务器
        this.saveHomeworkContent()
        // 隐藏弹窗
        this.homeworkContentDialogVisible = false
      }
    },
    
    // 编辑学生历史欠交记录的作业内容
    editHomeworkContent(row) {
      // 保存当前编辑的行
      this.editingRow = row

      // 将当前行的作业内容复制到临时变量
      this.tempHomeworkContent = row.content || ''
      // 显示作业内容输入弹窗
      this.homeworkContentDialogVisible = true
    },
    
    // 编辑历史欠交学生的作业内容
    editUnfinishedStudentHomeworkContent(row) {
      // 保存当前编辑的行
      this.editingRow = row

      // 将当前行的作业内容复制到临时变量
      this.tempHomeworkContent = row.content || ''
      // 显示作业内容输入弹窗
      this.homeworkContentDialogVisible = true
    },
    
    async locateToRecord(row) {
      // 关闭弹窗
      this.studentHistoryDialogVisible = false
      this.showStudentNoRecords = false; // 重置无记录状态

      // 设置日期
      this.localCurrentDate = row.date

      // 设置作业类型
      this.localSelectedType = row.homeworkTypeId

      // 先加载作业类型，确保selectedType在有效的作业类型列表中
      await this.loadHomeworkTypes()

      // 通过事件通知父组件刷新数据
      this.$emit('date-change', this.localCurrentDate);
      this.$emit('type-change', this.localSelectedType);
    },
    
    // 定位到历史欠交学生记录
    locateToUnfinishedRecord(row) {
      // 关闭弹窗
      this.unfinishedStudentsDialogVisible = false

      // 设置日期
      this.localCurrentDate = row.date

      // 通知父组件刷新数据
      this.$emit('date-change', this.localCurrentDate);
    },
    
    // 处理作业内容更新
    handleContentUpdated(data) {
      // 更新本地作业内容
      this.localHomeworkContent = data.content;
      
      // 触发更新事件，通知父组件
      this.$emit('update:homeworkContent', data.content);
    },
    
    // 处理批量录入的学生名单
    processImportStudents() {
      if (!this.importStudentsText.trim()) {
        this.$message({
          type: 'warning',
          message: '请输入学生名单'
        })
        return
      }

      const requestData = {
        inputText: this.importStudentsText,
        date: this.localCurrentDate,
        homeworkTypeId: this.localSelectedType,
        classId: this.classId
      }

      this.$http.post('/correctionRecords/batch-import', requestData)
        .then(response => {
          const { matchedCount, unmatchedLines, autoAssigned } = response.data.data
          
          // 显示未匹配的行
          if (unmatchedLines && unmatchedLines.length > 0) {
            this.unmatchedStudentsText = unmatchedLines.join('\n')
            this.unmatchedStudentsDialogVisible = true
          }
          
          // 关闭批量录入对话框
          this.importStudentsDialogVisible = false
          
          // 如果自动布置了作业，触发作业布置成功事件
          if (autoAssigned) {
            this.$emit('homework-assigned')
          } else {
            // 否则只刷新数据
            this.loadData()
          }
          
          // 显示成功提示
          let message = `成功匹配并标记${matchedCount}名学生为已完成`
          if (autoAssigned) {
            message += '，并自动布置了作业'
          }
          this.$message({
            type: 'success',
            message: message
          })
        })
        .catch(error => {
          console.error('批量录入失败:', error)
          this.$message.error('批量录入失败: ' + (error.response?.data?.message || error.message))
        })
    },
    
    // 导出学生欠交作业数据到剪贴板
    exportStudentData() {
      Utils.exportStudentData(this)
    },

    
    loadUnfinishedCounts() {
      // 获取所有学生在当前科目下的欠交数量（批量获取）
      const subjectId = this.subjectIndex + 1
      let url = `/correctionRecords/unfinishedCountBySubject?subjectId=${subjectId}`
      if (this.classId) {
        url = `/correctionRecords/unfinishedCountBySubject?subjectId=${subjectId}&classId=${this.classId}`
      }
      this.$http.get(url)
          .then(response => {
            const counts = {}
            response.data.forEach(item => {
              counts[item.studentId] = item.unfinishedCount
            })
            this.studentUnfinishedCounts = counts
          })
          .catch(error => {
            console.error('获取欠交数量失败:', error)
            this.$message({
              type: 'error',
              message: '获取欠交数量失败'
            })
          })
    },
    
    getSubjectIdByHomeworkType(homeworkTypeId) {
      // 根据作业类型ID获取科目ID
      const homeworkType = this.localHomeworkTypes.find(type => type.id === homeworkTypeId)
      return homeworkType ? homeworkType.subjectId : 1 // 默认为语文科
    },
    
    loadData() {
      // 构建API URL
      let correctionRecordsUrl = `/correctionRecords?date=${this.localCurrentDate}&typeId=${this.localSelectedType}`
      let homeworkContentsUrl = `/homeworkContents?date=${this.localCurrentDate}&typeId=${this.localSelectedType}`

      if (this.classId) {
        correctionRecordsUrl = `/correctionRecords?date=${this.localCurrentDate}&typeId=${this.localSelectedType}&classId=${this.classId}`
        homeworkContentsUrl = `/homeworkContents?date=${this.localCurrentDate}&typeId=${this.localSelectedType}&classId=${this.classId}`
      }

      // 加载订正记录
      this.$http.get(correctionRecordsUrl)
        .then(response => {
          // 发出事件让父组件更新correctionRecords
          this.$emit('update:correctionRecords', response.data)
          
          // 发出data-changed事件通知父组件
          this.$emit('data-changed');
        })

      // 加载作业内容
      this.$http.get(homeworkContentsUrl)
        .then(response => {
          // 检查响应状态码，204表示无内容
          if (response.status === 204) {
            this.localHomeworkContent = ''
          } else {
            this.localHomeworkContent = response.data ? response.data.content : ''
          }
        })
        .catch(() => {
          this.localHomeworkContent = ''
        })
      
      // 如果正在显示欠交数量，则重新加载欠交数量数据
      if (this.showUnfinishedCount) {
        this.loadUnfinishedCounts()
      }
    },
    
    loadHomeworkTypes() {
      let url = `/homeworkTypes?subjectId=${this.subjectIndex + 1}`
      if (this.classId) {
        url = `/homeworkTypes/class?classId=${this.classId}&subjectId=${this.subjectIndex + 1}`
      }
      return this.$http.get(url)
          .then(response => {
            this.localHomeworkTypes = response.data
            // 如果当前选中的作业类型不在新的列表中，则重置为第一个类型
            if (this.localHomeworkTypes.length > 0 && !this.localHomeworkTypes.some(type => type.id === this.localSelectedType)) {
              this.localSelectedType = this.localHomeworkTypes[0].id
            }
          })
    },
    
    sortStudentHistory(field, order) {
      this.studentHistorySortField = field
      this.studentHistorySortOrder = order

      this.studentHistoryRecords.sort((a, b) => {
        let result = 0

        if (field === 'date') {
          // 日期排序
          result = new Date(a.date) - new Date(b.date)
          // 如果日期相同，按作业类型ID升序排列
          if (result === 0) {
            result = a.homeworkTypeId - b.homeworkTypeId
          }
        } else if (field === 'typeName') {
          // 作业类型ID排序
          result = a.homeworkTypeId - b.homeworkTypeId
          // 如果作业类型ID相同，按日期升序排列
          if (result === 0) {
            result = new Date(a.date) - new Date(b.date)
          }
        }

        // 如果是降序，反转结果
        if (order === 'desc') {
          result = -result
        }

        return result
      })
    },
    
    sortUnfinishedStudents(field, order) {
      this.unfinishedStudentsSortField = field
      this.unfinishedStudentsSortOrder = order

      this.unfinishedStudents.sort((a, b) => {
        let result = 0

        if (field === 'studentNumber') {
          // 学号按数值大小排序
          const numA = parseInt(a.studentNumber)
          const numB = parseInt(b.studentNumber)
          result = numA - numB
        } else if (field === 'date') {
          // 日期排序
          result = new Date(a.date) - new Date(b.date)
          // 如果日期相同，按学号升序排列
          if (result === 0) {
            const numA = parseInt(a.studentNumber)
            const numB = parseInt(b.studentNumber)
            result = numA - numB
          }
        }

        // 如果是降序，反转结果
        if (order === 'desc') {
          result = -result
        }

        return result
      })
    },
    
    markAsFinished(row) {
      // 检查是否已经是完成状态，如果是则取消完成状态
      if (row.markedAsFinished) {
        // 取消完成状态
        row.corrected = false
        // 确保classId被设置
        if (this.classId && !row.classId) {
          row.classId = this.classId
        }
        this.$http.post('/correctionRecords', row)
            .then(() => {
              this.$message({
                type: 'success',
                message: '已取消订正状态!'
              })

              // 取消标记该行已处理
              this.$delete(row, 'markedAsFinished')

              // 刷新主页面数据
              this.loadData()
              // 如果开启了欠交数量显示，则更新欠交数量
              if (this.showUnfinishedCount) {
                this.loadUnfinishedCounts()
              }
              
              // 通知父组件刷新数据
              this.$emit('data-changed')
            })
            .catch(error => {
              row.corrected = true // 恢复原始状态
              this.$message({
                type: 'error',
                message: '取消订正状态失败: ' + (error.response?.data?.message || error.message || '未知错误')
              })
            })
      } else {
        // 标记为完成状态
        row.corrected = true
        // 确保classId被设置
        if (this.classId && !row.classId) {
          row.classId = this.classId
        }
        this.$http.post('/correctionRecords', row)
            .then(() => {
              this.$message({
                type: 'success',
                message: '标记成功!'
              })

              // 标记该行已处理，但不从列表中移除
              this.$set(row, 'markedAsFinished', true)

              // 如果标记的是当前日期的记录，也需要更新主页面的数据
              if (row.date === this.localCurrentDate) {
                this.loadData()
              }

              // 如果开启了欠交数量显示，则更新欠交数量
              if (this.showUnfinishedCount) {
                this.loadUnfinishedCounts()
              }
              
              // 通知父组件刷新数据
              this.$emit('data-changed')
            })
            .catch(error => {
              row.corrected = false // 恢复原始状态
              this.$message({
                type: 'error',
                message: '标记失败: ' + (error.response?.data?.message || error.message || '未知错误')
              })
            })
      }
    },
    
    markUnfinishedStudentAsFinished(row) {
      
      // 检查是否已经是完成状态，如果是则取消完成状态
      if (row.markedAsFinished) {
        // 首先需要找到该学生的订正记录ID
        let url = `/correctionRecords?date=${row.rawDate}&typeId=${this.localSelectedType}`;
        if (this.classId) {
          url = `/correctionRecords?date=${row.rawDate}&typeId=${this.localSelectedType}&classId=${this.classId}`;
        }
        this.$http.get(url)
            .then(response => {
              // 在返回的记录中找到对应学生的记录
              const student = this.students.find(s => s.studentNumber === row.studentNumber)
              if (student) {
                const record = response.data.find(r => r.studentId === student.id)
                if (record) {
                  // 更新记录状态为未完成
                  record.corrected = false
                  // 确保classId被设置
                  if (this.classId && !record.classId) {
                    record.classId = this.classId
                  }
                  console.log('ControlPanel: 发送POST请求更新记录', record);
                  return this.$http.post('/correctionRecords', record)
                }
              }
              return Promise.reject("未找到对应记录")
            })
            .then(() => {
              // 取消标记该行已处理
              this.$delete(row, 'markedAsFinished')

              // 如果标记的是当前日期的记录，也需要更新主页面的数据
              if (row.date === this.localCurrentDate) {
                this.loadData()
              }

              this.$message({
                type: 'success',
                message: '已取消订正状态!'
              })

              // 如果开启了欠交数量显示，则更新欠交数量
              if (this.showUnfinishedCount) {
                this.loadUnfinishedCounts()
              }
            })
            .catch(error => {
              this.$message({
                type: 'error',
                message: '取消订正状态失败: ' + (error.response?.data?.message || error.message || '未知错误')
              })
            })
      } else {
        // 标记历史欠交学生为已完成
        // 首先需要找到该学生的订正记录ID
        let url = `/correctionRecords?date=${row.rawDate}&typeId=${this.localSelectedType}`;
        if (this.classId) {
          url = `/correctionRecords?date=${row.rawDate}&typeId=${this.localSelectedType}&classId=${this.classId}`;
        }
        console.log('ControlPanel: 请求订正记录URL', url);
        
        this.$http.get(url)
            .then(response => {
              // 在返回的记录中找到对应学生的记录
              const student = this.students.find(s => s.studentNumber === row.studentNumber)
              
              if (student) {
                const record = response.data.find(r => r.studentId === student.id)
                
                if (record) {
                  // 更新记录状态为已完成
                  record.corrected = true
                  // 确保classId被设置
                  if (this.classId && !record.classId) {
                    record.classId = this.classId
                  }
                  return this.$http.post('/correctionRecords', record)
                }
              }
              return Promise.reject("未找到对应记录")
            })
            .then(() => {
              // 标记该行已处理，但不从列表中移除
              this.$set(row, 'markedAsFinished', true)

              // 如果标记的是当前日期的记录，也需要更新主页面的数据
              if (row.date === this.localCurrentDate) {
                this.loadData();
              } else {
                // 日期不匹配，不刷新主页面数据
              }

              this.$message({
                type: 'success',
                message: '标记成功!'
              })

              // 发出data-changed事件通知父组件
              this.$emit('data-changed');

              // 如果开启了欠交数量显示，则更新欠交数量
              if (this.showUnfinishedCount) {
                this.loadUnfinishedCounts();
              }
              
              // 不再发出stats-should-update事件，让StudentGrid自己处理统计更新
            })
            .catch(error => {
              this.$message({
                type: 'error',
                message: '标记失败: ' + (error.response?.data?.message || error.message || '未知错误')
              })
            })
      }
    },
    
    // 显示历史欠交学生
    showUnfinishedStudents() {
      let url = `/correctionRecords/unfinishedStudentsWithContent?typeId=${this.localSelectedType}`
      if (this.classId) {
        url = `/correctionRecords/unfinishedStudentsWithContent?typeId=${this.localSelectedType}&classId=${this.classId}`
      }
      this.$http.get(url)
          .then(response => {
            const unfinishedStudents = response.data.map(item => {
              // 格式化日期
              let formattedDate = item.date
              if (typeof item.date === 'string' && item.date.includes('T')) {
                // 如果是ISO格式日期，转换为 yyyy-MM-dd
                const date = new Date(item.date)
                formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
              }

              // 计算星期几
              const dateObj = new Date(formattedDate)
              const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
              const weekDay = weekDays[dateObj.getDay()]

              return {
                date: formattedDate,
                weekDay: weekDay,
                studentNumber: item.studentNumber,
                name: item.name,
                homeworkTypeId: item.homeworkTypeId || this.localSelectedType, // 使用接口返回的homeworkTypeId
                rawDate: formattedDate, // 保存格式化后的日期用于查询作业内容
                formattedDate: formattedDate, // 保存格式化后的日期用于查询作业内容
                content: item.content || '' // 使用接口返回的作业内容
              }
            })

            // 赋值给组件数据
            this.unfinishedStudents = unfinishedStudents

            // 默认按日期升序排序
            this.sortUnfinishedStudents('date', 'asc')
            this.unfinishedStudentsDialogVisible = true
          })
          .catch(error => {
            console.error('获取未完成学生数据失败:', error)
            this.$message({
              type: 'error',
              message: '获取数据失败: ' + (error.response?.data?.message || error.message || '未知错误')
            })
          })
    },
    
    // 显示批量录入对话框
    showImportStudentsDialog() {
      this.importStudentsText = ''
      this.importStudentsDialogVisible = true
    },
    
    // 处理作业类型更新
    handleHomeworkTypesUpdated(payload) {
      console.log('ControlPanel收到作业类型更新通知:', payload);
      
      // 检查是否是当前班级的作业类型更新
      if (payload.classId === this.classId) {
        // 重新加载作业类型数据
        this.loadHomeworkTypes().then(() => {
          console.log('ControlPanel作业类型数据已刷新');
          // 如果当前选中的作业类型被删除，重置为第一个类型
          if (this.localHomeworkTypes.length > 0 && 
              !this.localHomeworkTypes.some(type => type.id === this.localSelectedType)) {
            this.localSelectedType = this.localHomeworkTypes[0].id;
            // 通知父组件作业类型已改变
            this.$emit('type-change', this.localSelectedType);
            // 重新加载作业内容
            this.loadHomeworkContent();
          }
          
          // 通过.sync修饰符通知父组件更新homeworkTypes属性
          this.$emit('update:homeworkTypes', this.localHomeworkTypes);
        }).catch(error => {
          console.error('ControlPanel刷新作业类型数据失败:', error);
        });
      }
    },
    
    // 处理作业内容更新事件
    handleHomeworkContentUpdated(payload) {
      console.log('ControlPanel收到作业内容更新通知:', payload);
      
      // 检查是否是当前班级的作业内容更新
      if (payload.classId === this.classId) {
        // 检查是否是当前日期和作业类型的更新
        const currentDateStr = new Date(this.localCurrentDate).toDateString();
        const payloadDateStr = new Date(payload.date).toDateString();
        
        if (currentDateStr === payloadDateStr && this.localSelectedType === payload.typeId) {
          // 更新本地作业内容
          this.localHomeworkContent = payload.content;
          console.log('ControlPanel作业内容已更新为:', payload.content);
        }
      }
    },
    

    

  },
  
  mounted() {
    // 初始化高亮状态
    this.$nextTick(() => {
      this.setHighlightedShortcut()
    })
    
    // 监听事件总线的作业类型更新事件
    EventBus.$on('homework-types-updated', this.handleHomeworkTypesUpdated);
    
    // 监听事件总线的作业内容更新事件
    EventBus.$on('homework-content-updated', this.handleHomeworkContentUpdated);
  },
  
  beforeDestroy() {
    // 移除事件总线监听器
    EventBus.$off('homework-types-updated', this.handleHomeworkTypesUpdated);
    EventBus.$off('homework-content-updated', this.handleHomeworkContentUpdated);
  },
}
</script>